import * as TransferActions from './transfer.actions';

export const INITIAL_STATE = {
  transferkeys: [],
  transferAssets: [],
  transferStatus: undefined
};

export const TRANSFER_STATE_NAME = 'transfer';

export const TransferStatusEnum = Object.freeze({
  TRANSFERRING: 'transferring',
  SUCCESS: 'success',
  FAILED: 'failed',
  PART_FAILED: 'part_failed'
});

class AssetTransfer {
  constructor(asset = {}) {
    this.id = asset.id;
    this.name = asset.name || asset.id;
    this.installationId = '';
    this.status = TransferStatusEnum.TRANSFERRING;
    this.message = '';
  }

  updateFromInstallations(Installations = []) {
    const installation = Installations.find(install => install.equipment.id === this.id);
    if (installation) {
      this.installationId = installation.id;
    } else {
      this.installationId = '';
      this.updateStatus('failed', 'Unable to get asset installation');
    }
  }

  updateStatus(status, message) {
    this.status = status;
    this.message = message;
  }
}

const getTransferringStatus = (transferAssetsList = []) => {
  let transferStatus = undefined;
  if (transferAssetsList.length > 0) {
    //note every will return true on empty array
    if (transferAssetsList.filter(asset => asset.status === TransferStatusEnum.TRANSFERRING).length > 0) {
      transferStatus = TransferStatusEnum.TRANSFERRING;
    } else if (transferAssetsList.every(asset => asset.status === TransferStatusEnum.SUCCESS)) {
      transferStatus = TransferStatusEnum.SUCCESS;
    } else if (transferAssetsList.every(asset => asset.status === TransferStatusEnum.FAILED)) {
      transferStatus = TransferStatusEnum.FAILED;
    } else {
      transferStatus = TransferStatusEnum.PART_FAILED;
    }
  }

  return transferStatus;
};

export default (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case TransferActions.TRANSFER_ASSETS: {
      const newtransferAssets = state.transferAssets.map(asset => {
        asset.updateFromInstallations(payload.installations);
        return asset;
      });
      return {
        ...state,
        transferAssets: newtransferAssets,
        transferStatus: getTransferringStatus(newtransferAssets)
      };
    }
    case TransferActions.INITIATE_ASSET_TRANSFER: {
      const newtransferAssets = payload.assets.map(asset => new AssetTransfer(asset));
      return {
        ...state,
        transferAssets: newtransferAssets,
        transferStatus: getTransferringStatus(newtransferAssets)
      };
    }
    case TransferActions.INITIATE_ASSET_TRANSFER_FAIL: {
      const error = 'Failed to get installation';
      const newtransferAssets = state.transferAssets.map(asset => {
        asset.updateStatus(TransferStatusEnum.FAILED, error);
        return asset;
      });
      return {
        ...state,
        transferAssets: newtransferAssets,
        transferStatus: getTransferringStatus(newtransferAssets)
      };
    }
    case TransferActions.TRANSFER_ASSET_SUCCESS: {
      const newtransferAssets = state.transferAssets.map(transfer => {
        if (payload && transfer.installationId === payload) {
          transfer.updateStatus(TransferStatusEnum.SUCCESS, 'Transfer completed successfully');
        }
        return transfer;
      });
      return {
        ...state,
        transferAssets: newtransferAssets,
        transferStatus: getTransferringStatus(newtransferAssets)
      };
    }
    case TransferActions.TRANSFER_ASSET_FAIL: {
      let errorMessage = 'Transferring Assets failed.';
      let {data} = payload.error;
      if (data && data.Message) {
        errorMessage = data.Message;
      }
      const newtransferAssets = state.transferAssets.map(transfer => {
        if (payload.installationId && transfer.installationId === payload.installationId) {
          transfer.updateStatus(TransferStatusEnum.FAILED, errorMessage);
        }
        return transfer;
      });

      return {
        ...state,
        transferAssets: newtransferAssets,
        transferStatus: getTransferringStatus(newtransferAssets)
      };
    }
    case TransferActions.RESET_TRANSFERS: {
      const notTransferring = state.transferStatus !== TransferStatusEnum.TRANSFERRING;
      return {
        ...state,
        transferAssets: notTransferring ? [] : state.transferAssets,
        transferStatus: notTransferring ? undefined : state.transferStatus
      };
    }
    case TransferActions.GET_TRANSFERKEYS_SUCCESS: {
      const {transferKeys = []} = payload;
      return {
        ...state,
        transferkeys: transferKeys.filter(
          key => key.permissions && key.permissions.resources && key.permissions.resources.includes('installations')
        )
      };
    }
    case TransferActions.GET_TRANSFERKEYS_FAIL: {
      return {
        ...state,
        transfer_error: payload
      };
    }
    default:
      return state;
  }
};
